import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {Dialog} from '../Dialog'

// "(Vista 51Trips) Agencia creada - Popup": the agencies list is rebuilt from
// the database every 15 minutes, so a new agency isn't in it yet.
export const AgencyCreatedDialog = forwardRef<{open: (agencyName: string) => void}>((_, ref) => {
    const {t} = useTranslation('dashboard')
    const dialog = useRef<React.ElementRef<typeof Dialog<boolean>>>(null)
    const [agencyName, setAgencyName] = useState('')

    useImperativeHandle(ref, () => ({
        open: (name: string) => {
            setAgencyName(name)
            dialog.current!.open()
        },
    }), [])

    return (
        <Dialog ref={dialog} customWidth="420px" childrenPadding="px-7 pt-8 pb-6"
                panelClassName="rounded-[20px] border border-neutralBlack-200">
            <div className="flex flex-col items-center gap-4 text-center">
                <span className="size-12 rounded-full bg-[#D9F5E4] flex items-center justify-center text-[#0F7A45]">
                    <svg viewBox="0 0 20 20" className="size-5" fill="none" stroke="currentColor" strokeWidth="2.2"
                         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M4.5 10.5 8.2 14 15.5 6.5"/>
                    </svg>
                </span>
                <h2 className="text-[19px] font-bold leading-[1.3] tracking-[-0.01em] text-neutralBlack-900 text-pretty">
                    {t('agencyCreated.title', {name: agencyName})}
                </h2>
                <p className="text-[14px] leading-[1.6] text-neutralBlack-500 text-pretty">
                    <Trans t={t} i18nKey="agencyCreated.message"
                           components={{strong: <strong className="font-semibold text-neutralBlack-900"/>}}/>
                </p>
                <button type="button" onClick={() => dialog.current!.close()} autoFocus
                        className="mt-2 w-full h-12 rounded-full bg-neutralBlack-900 text-white text-[15px] font-semibold transition-colors duration-200 ease-out hover:bg-neutralBlack-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutralBlack-900">
                    {t('agencyCreated.ok')}
                </button>
            </div>
        </Dialog>
    )
})
